<template>
    <div>
        <v-form class="pa-2" @submit.prevent="handleUserUpdateUpload">
            <file-input-field
                v-model="file"
                accept=".csv"
                placeholder="Ziehen Sie die CSV-Datei den neuen E-Mails hier rein..."
                label="Ziehen Sie die CSV-Datei den neuen E-Mails hier rein..."
                data-test="input-upload-user-update"
                :violation-fields="['fileData']"
                :error="error"
                :is-loading="isLoading"
                :disabled="userUploadState === null"
            />
            <v-btn
                type="submit"
                block
                color="primary"
                variant="tonal"
                data-test="button-upload-user-update"
                :disabled="!userUploadState || isLoading"
                class="mt-2"
            >
                Benutzeraktualisierung starten
            </v-btn>
            <global-form-error :error="globalErrors" is-html />
            <success-alert :show="isFinished" message="Benutzer erfolgreich aktualisiert." />
            <info-alert :show="true">
                <b>Hinweis:</b>
                <ul class="mb-0">
                    <li>
                        Nutzer werden anhand ihrer alten E-Mail identifiziert und es wird eine neue
                        E-Mail vergeben.
                    </li>
                    <li>
                        Import-Fehler werden hier angezeigt sowie im Import-Logfile gespeichert.
                    </li>
                </ul>
            </info-alert>
        </v-form>
    </div>
</template>

<script>
    'use strict'
    import {
        FileInputField,
        GlobalFormError,
        InfoAlert,
        SuccessAlert
    } from '@/js/components/Common'
    import { getViolationsFeedback, useUploadFile } from '@/js/utils'

    export default {
        name: 'UserUpload',
        components: {
            FileInputField,
            GlobalFormError,
            SuccessAlert,
            InfoAlert
        },
        setup() {
            const { file, readFileAsUrl } = useUploadFile()

            return { file, readFileAsUrl }
        },
        data: function () {
            return {
                isFinished: false
            }
        },
        computed: {
            userUploadState() {
                if (null === this.file) {
                    return
                }

                return Boolean(this.file)
            },
            isLoading() {
                return this.$store.getters['user/isLoading']
            },
            error() {
                return this.$store.getters['user/error']
            },
            globalErrors() {
                return getViolationsFeedback(['fileData'], this.error, true)
            }
        },
        mounted() {
            this.isFinished = false
        },
        methods: {
            async handleUserUpdateUpload() {
                this.isFinished = await this.$store.dispatch(
                    'user/uploadUserUpdateFile',
                    await this.readFileAsUrl()
                )
            }
        }
    }
</script>

<style scoped></style>
